export const SNOWPACK_PUBLIC_APP_VERSION = import.meta.env.VITE_PUBLIC_APP_VERSION ?? ''
export const SNOWPACK_PUBLIC_APP_VERSION_POLLING_RATE = import.meta.env.VITE_PUBLIC_APP_VERSION_POLLING_RATE
  ? Number(import.meta.env.VITE_PUBLIC_APP_VERSION_POLLING_RATE)
  : 60000
